
import moment from 'moment';
import CommonMixin from '@/core/pages/CommonMixin';
import { Component, Prop } from 'vue-property-decorator';
import { Booking } from '@/models/bookings';
import { Driver } from '@/models/users';

interface DriverInfo {
  name?: string;
  date: string;
}

@Component
export default class OtherBookings extends CommonMixin {
  @Prop() readonly previous_bookings: Booking[];
  @Prop() readonly next_bookings: Booking[];
  @Prop() readonly drivers: Driver[];

  get hasPreviousDriver(): boolean {
    return this.previous_bookings.length > 0;
  }

  get getPreviousDriver(): DriverInfo {
    const previous_booking = this.previous_bookings[this.previous_bookings.length - 1];
    const driver = this.drivers.find(({ driver }) => driver.id === previous_booking.driverId);
    return {
      name: driver?.driver.name ?? previous_booking.driverName,
      date: moment(previous_booking.endDate).locale(this.getUserLanguage).format('HH:mm - DD MMMM YYYY'),
    };
  }

  get hasNextDriver(): boolean {
    return this.next_bookings.length > 0;
  }

  get getNextDriver(): DriverInfo {
    const next_booking = this.next_bookings[0];
    const driver = this.drivers.find(({ driver }) => driver.id === next_booking.driverId);
    return {
      name: driver?.driver.name,
      date: moment(next_booking.startDate).locale(this.getUserLanguage).format('HH:mm - DD MMMM YYYY'),
    };
  }
}
